import withPGTranslation from '../../../config/withPGTranslation';
import Footer from './footer';

export default withPGTranslation(Footer);
